import React from 'react';
import cn from 'classnames';
import { Form, InputNumber as InputAntd } from 'antd';
import { InputNumberProps } from './types';
import './style.scss';

export const InputNumber: React.FC<InputNumberProps> = ({ className, name, label, rules, formItemProps, ...props }) => {
  return (
    <div className={cn('form-item_input-number', className)}>
      <Form.Item name={name} label={label} rules={rules} labelCol={{ span: 24 }} {...formItemProps}>
        <InputAntd {...props} />
      </Form.Item>
    </div>
  );
};
